<template>
  <div class="search-index" v-loading="loading">
    <div>
      <h-search :open-flag="true" @search="searchClick"></h-search>
    </div>
    <div class="search-main">
      <div class="search-type">
        <el-tabs v-model="contentType" @tab-click="contentTypeClick">
          <div class="search-keyword" v-if="searchStr">
            <span>关键词：<span style="color: red">{{searchStr}}</span></span>
          </div>

          <el-tab-pane label="随笔" name="essay" value="'1'">
            <transition name="tab-fade">
            <div class="search-content" v-if="contentType == 'essay'">
              <template v-for="(essayObj,index) in essayList">
                <div class="content-card" :key="index">
                  <essay-component :essay-obj="essayObj" @click="essayCLick(essayObj)"></essay-component>
                </div>
              </template>
            </div>
            <div v-if="essayList.length == 0">
              <span>抱歉，没有找到相关内容。</span>
            </div>
            </transition>
          </el-tab-pane>

          <el-tab-pane label="心情" name="post" value="'2'">
            <transition name="tab-fade">
            <div class="search-content" v-if="contentType == 'post'">
              <template v-for="(postObj,index) in postList">
                <div class="content-card" :key="index">
                  <post-component :post-obj="postObj" @click="postCLick(postObj)"></post-component>
                </div>
              </template>
            </div>
            <div v-if="postList.length == 0">
              <span>抱歉，没有找到相关内容。</span>
            </div>
            </transition>
          </el-tab-pane>
        </el-tabs>

      </div>
      <div class="search-page">
        <el-pagination
            layout="prev, pager, next"
            :current-page="page.pageNum"
            :page-size="page.pageSize"
            :total="page.total"
            :hide-on-single-page="true"
            @current-change="pageChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import HHeader from '@/page/components/h-header'
import HSearch from '@/page/components/h-search'
import EssayComponent from '@/page/essay/essayComponent'
import {  getEssayListPage } from '@/api/essayApi'
import { getPostList } from '@/api/postApi'
import PostComponent from '@/page/post/postComponent'

export default {
  name: 'index',
  components: { PostComponent, EssayComponent, HSearch, HHeader },
  data(){
    return{
      temp:false,
      loading:false,
      contentType:'essay',
      page:{
        pageSize:5,
        pageNum:1,
        total:0,
      },
      essayList:[],
      postList:[],
      searchStr:'',
    }
  },
  mounted() {
    this.searchClick();
  },
  methods:{
    queryEssay(keywordCheckList){
      const $this = this;
      let params = {...$this.page};
      if($this.searchStr){
        params.title = $this.searchStr;
      }
      params.tagList = keywordCheckList;
      $this.loading = true;
      getEssayListPage(params).then(res=>{
        $this.essayList = res.rows;
        $this.page.total = res.total;
        $this.goTop();
      }).finally(()=>{
        $this.loading = false;
      })
    },
    queryPost(){
      const $this = this;
      let params = {...$this.page};
      if($this.searchStr){
        params.content = $this.searchStr;
      }
      $this.loading = true;
      getPostList(params).then(res=>{
        $this.postList = res.rows;
        $this.page.total = res.total;
        $this.goTop();
      }).finally(()=>{
        $this.loading = false;
      })
    },
    pageChange(currentPage){
      this.page.pageNum = currentPage;
      this.searchClick();

      this.$forceUpdate()
    },
    searchClick(searchStr,keywordCheckList){
      this.searchStr = searchStr;
      switch (this.contentType){
        case 'essay':
          this.queryEssay(keywordCheckList);
          break
        case 'post':
          this.queryPost(keywordCheckList);
          break;
      }
    },
    goTop(){
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    },
    essayCLick(essayObj){
      let params = {};
      params.essayId = essayObj.id;
      this.$router.push({ path: '/essay', query: params});
    },
    postCLick(postObj){
      let params = {};
      params.postId = postObj.id;
      this.$router.push({ path: '/post', query: params});
    },
    contentTypeClick(tab, event){
      this.contentType = tab.name;
      this.page.pageNum = 1;
      this.searchClick(this.searchStr);
    }
  },
  watch:{
    '$route.query.keyword'(newValue, oldValue) {
      // let arr = [newValue];
      // this.queryEssay(arr);
    },
  },
}
</script>

<style scoped>
.search-index{
  /*padding-top: 178px;*/
  /*z-index: 99;*/
  background: #fff;
  width: 100%;
  /*height: 100%;*/
  min-height: 100%;
}
.search-main{
  margin: 20px 20% 0;
}
.search-type{
  text-align: left;
  margin-bottom: 10px;
}
.content-title{
  margin: 0 10px 0 0;
  font-size: 20px;
  cursor: pointer;
}
.content-title-checked{
  color: #007BFF;
  text-decoration: underline;
}
/* 过渡类名 */
.tab-fade-enter-active, .tab-fade-leave-active {
  transition: opacity 1.5s;
}
/* 进入过渡的初始状态和离开过渡的结束状态 */
.tab-fade-enter, .tab-fade-leave-to /* .tab-fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
/* 离开过渡的初始状态和进入过渡的结束状态 */
.tab-fade-enter-to, .tab-fade-leave {
  opacity: 1;
}

.search-page{
  text-align: right;
}
.search-content{
  /*width: 95%;*/
  /*margin: 0 auto;*/
  padding: 0px 10px;
}
.content-card{
  /*box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);*/
  margin: 5px 0;
}
</style>
